import type { TCockpitAttentionGrouping } from '../../model/types'

const STORAGE_KEY = '__partner360-cockpit-attention-grouping'

const GROUPINGS: TCockpitAttentionGrouping[] = ['market', 'pbm', 'manager', 'partner']

const isGrouping = (value: string | null): value is TCockpitAttentionGrouping =>
  GROUPINGS.some((grouping) => grouping === value)

/**
 * The grouping the reader last picked, kept per browser.
 *
 * A manager works the cockpit the same way every day — by market, or by the PBMs they answer to —
 * so the choice is theirs rather than the session's. Whether the role may use it is checked where
 * it is read. Anything else in the store is derived from
 * the payload and is not worth remembering.
 */
export const readStoredAttentionGrouping = (): TCockpitAttentionGrouping | null => {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const stored = window.localStorage.getItem(STORAGE_KEY)

    return isGrouping(stored) ? stored : null
  } catch {
    /* A denied storage costs the reader their last choice, never the tile. */
    return null
  }
}

export const storeAttentionGrouping = (grouping: TCockpitAttentionGrouping): void => {
  if (typeof window === 'undefined') {
    return
  }

  try {
    window.localStorage.setItem(STORAGE_KEY, grouping)
  } catch {
    // Storage the browser refuses must not stop the tile from regrouping.
  }
}
